'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _ArrayModels = require('@vezeeta/enterprise-utils/lib/ArrayModels');

var _prefixTitles = require('../actions/prefixTitles');

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var initialState = {
  prefixTitles: new Map(),
  prefixTitlesNames: new Map(),
  prefixTitlesState: undefined
};

exports.default = function () {
  var state /*: Object*/ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];

  var type = _ref.type,
      payload = _objectWithoutProperties(_ref, ['type']);

  switch (type) {
    case _prefixTitles.PREFIX_TITLES.LOADING:
      {
        return _extends({}, state, {
          prefixTitlesState: _prefixTitles.PREFIX_TITLES.LOADING
        });
      }

    case _prefixTitles.PREFIX_TITLES.SUCCEEDED:
      {
        var prefixTitles = new Map();
        var prefixTitlesNames = new Map();

        if (payload.prefixTitles) {
          payload.prefixTitles.forEach(function (prefixTitle) {
            prefixTitles.set(prefixTitle.PrefixTitleId, prefixTitle);

            var _generateMapsFromArra = (0, _ArrayModels.generateMapsFromArrayModels)(prefixTitle.PrefixTitleLanguageItemModels, 'LanguageId', ['Name']),
                Name = _generateMapsFromArra.Name;

            prefixTitlesNames.set(prefixTitle.PrefixTitleId, Name);
          });
        }

        return _extends({}, state, {
          prefixTitles: prefixTitles,
          prefixTitlesNames: prefixTitlesNames,
          prefixTitlesState: _prefixTitles.PREFIX_TITLES.SUCCEEDED
        });
      }

    case _prefixTitles.PREFIX_TITLES.FAILED:
      {
        return _extends({}, state, {
          prefixTitles: new Map(),
          prefixTitlesState: _prefixTitles.PREFIX_TITLES.FAILED
        });
      }

    default:
      {
        return state;
      }
  }
};

module.exports = exports['default'];